
const getFeatureFlagValue = (flag) => {
  const value = flag?.trim().toLowerCase();

  if (value === 'true') {
    return true;
  }

  return false;
}

const {
  REACT_APP_FEATURE_FLAG_CREDITS,
  REACT_APP_FEATURE_APPLICATION_DATE,
  REACT_APP_FEATURE_PAYMENT_REPORTS,
  REACT_APP_FEATURE_OVERPAYMENT,
  REACT_APP_FEATURE_SUBSCRIPTION_NAME,
  REACT_APP_FEATURE_CARRYOVER_RATE,
  REACT_APP_FEATURE_PAYMENT_PDF,
  REACT_APP_FEATURE_BUSINESS_NAME,
  REACT_APP_FEATURE_OVERPAYMENT_PT2_I,
  REACT_APP_FEATURE_OVERPAYMENT_PT2_C,
  REACT_APP_FEATURE_MYACCOUNT,
  REACT_APP_FEATURE_INVOICE_REPORT_CSV,
  REACT_APP_FEATURE_INVOICE_REPORT_CSV_2,
  REACT_APP_FEATURE_INVOICE_REPORT_CSV_3,
  REACT_APP_FEATURE_BUSINESSDAYS,
  REACT_APP_FEATURE_REVERSE_APPLICATIONDATE,
  REACT_APP_FEATURE_OBALANCE,
  REACT_APP_FEATURE_OBSUMMARY,
  REACT_APP_FEATURE_APPDATEOVERRIDE,
  REACT_APP_FEATURE_PAYOR_SEARCH,
  REACT_APP_FEATURE_INVOICE_REPORTPDF,
  REACT_APP_FEATURE_INVOICE_SEND,
  REACT_APP_FEATURE_ACCOUNT_ID,
  REACT_APP_FEATURE_UNAPPLY_CREDIT,
  REACT_APP_FEATURE_PAYMENT_SUMMARY,
  REACT_APP_FEATURE_CREDIT_UPDATES,
  REACT_APP_FEATURE_ADMIN_PAYMENT_SETTINGS,
  REACT_APP_FEATURE_ACCOUNTING_CREDITS,
  REACT_APP_FEATURE_CARRYOVER_CREDIT,
  REACT_APP_FEATURE_DISCOUNT_CREDIT,
  REACT_APP_FEATURE_UNIVERSAL_SEARCH,
  REACT_APP_FEATURE_PAYMENT_TYPES,
  REACT_APP_FEATURE_REACT_18_SUBSCRIPTION_PAGE,
} = process.env;

export default {
  CREDITS: getFeatureFlagValue(REACT_APP_FEATURE_FLAG_CREDITS),
  APPLICATION_DATE: getFeatureFlagValue(REACT_APP_FEATURE_APPLICATION_DATE),
  PAYMENT_REPORTS: getFeatureFlagValue(REACT_APP_FEATURE_PAYMENT_REPORTS),
  OVERPAYMENT: getFeatureFlagValue(REACT_APP_FEATURE_OVERPAYMENT),
  SUBSCRIPTION_NAME: getFeatureFlagValue(REACT_APP_FEATURE_SUBSCRIPTION_NAME),
  CARRYOVER_RATE: getFeatureFlagValue(REACT_APP_FEATURE_CARRYOVER_RATE),
  PAYMENT_PDF: getFeatureFlagValue(REACT_APP_FEATURE_PAYMENT_PDF),
  BUSINESS_NAME: getFeatureFlagValue(REACT_APP_FEATURE_BUSINESS_NAME),
  OVERPAYMENT_PT2_I: getFeatureFlagValue(REACT_APP_FEATURE_OVERPAYMENT_PT2_I),
  OVERPAYMENT_PT2_C: getFeatureFlagValue(REACT_APP_FEATURE_OVERPAYMENT_PT2_C),
  MYACCOUNT: getFeatureFlagValue(REACT_APP_FEATURE_MYACCOUNT),
  INVOICE_REPORT_CSV: getFeatureFlagValue(REACT_APP_FEATURE_INVOICE_REPORT_CSV),
  INVOICE_REPORT_CSV_2: getFeatureFlagValue(REACT_APP_FEATURE_INVOICE_REPORT_CSV_2),
  INVOICE_REPORT_CSV_3: getFeatureFlagValue(REACT_APP_FEATURE_INVOICE_REPORT_CSV_3),
  BUSINESSDAYS: getFeatureFlagValue(REACT_APP_FEATURE_BUSINESSDAYS),
  REVERSE_APPLICATIONDATE: getFeatureFlagValue(REACT_APP_FEATURE_REVERSE_APPLICATIONDATE),
  OBALANCE: getFeatureFlagValue(REACT_APP_FEATURE_OBALANCE),
  OBSUMMARY: getFeatureFlagValue(REACT_APP_FEATURE_OBSUMMARY),
  APPDATEOVERRIDE: getFeatureFlagValue(REACT_APP_FEATURE_APPDATEOVERRIDE),
  PAYOR_SEARCH: getFeatureFlagValue(REACT_APP_FEATURE_PAYOR_SEARCH),
  INVOICE_REPORTPDF: getFeatureFlagValue(REACT_APP_FEATURE_INVOICE_REPORTPDF),
  INVOICE_SEND: getFeatureFlagValue(REACT_APP_FEATURE_INVOICE_SEND),
  ACCOUNT_ID: getFeatureFlagValue(REACT_APP_FEATURE_ACCOUNT_ID),
  UNAPPLY_CREDIT: getFeatureFlagValue(REACT_APP_FEATURE_UNAPPLY_CREDIT),
  PAYMENT_SUMMARY: getFeatureFlagValue(REACT_APP_FEATURE_PAYMENT_SUMMARY),
  CREDIT_UPDATES: getFeatureFlagValue(REACT_APP_FEATURE_CREDIT_UPDATES),
  ADMIN_PAYMENT_SETTINGS: getFeatureFlagValue(REACT_APP_FEATURE_ADMIN_PAYMENT_SETTINGS),
  ACCOUNTING_CREDITS: getFeatureFlagValue(REACT_APP_FEATURE_ACCOUNTING_CREDITS),
  CARRYOVER_CREDIT: getFeatureFlagValue(REACT_APP_FEATURE_CARRYOVER_CREDIT),
  DISCOUNT_CREDIT: getFeatureFlagValue(REACT_APP_FEATURE_DISCOUNT_CREDIT),
  FEATURE_UNIVERSAL_SEARCH: getFeatureFlagValue(REACT_APP_FEATURE_UNIVERSAL_SEARCH),
  PAYMENT_TYPES: getFeatureFlagValue(REACT_APP_FEATURE_PAYMENT_TYPES),
  REACT_18_SUBSCRIPTION_PAGE: getFeatureFlagValue(REACT_APP_FEATURE_REACT_18_SUBSCRIPTION_PAGE),
}
